import { connect } from "react-redux";
import ScrollIntoView from "../../../shared/scroll-into-view/scroll-into-view";
import CopyBackgroundActors from "./copy";
import { fetchFilms } from "../../film/ducks/actions";
import { copyBackgroundActors, clearRedirect } from "./ducks/actions";
import { useEffect, useState } from "react";
import Loader from "../../../shared/loader";
import { Redirect } from "react-router-dom";
import Onboarding from "../../../shared/onboarding/onboarding";

const CopyBackgroundActorsContainer = (props) => {
    const { fetchFilms, copyBackgroundActors, films, loadingFilms, redirect, clearRedirect, importing, onboardingSteps } = props;
    const { filmId } = props.match.params;

    const [filmsExcludingThisOne, setFilmsExcludingThisOne] = useState<any[]>([]);
    const [selectedFilm, setSelectedFilm] = useState<any>(null);
    const [sameFilm, setSameFilm] = useState<boolean>(true);

    const onChangeFilm = (film) => {
        setSelectedFilm(film);
    };

    useEffect(() => {
        fetchFilms();
    }, []);

    useEffect(() => {
        if (films?.length) {
            setFilmsExcludingThisOne(films.filter(film => film.id != filmId));
        }
    }, [filmId, films?.length]);

    useEffect(() => {
        if (filmsExcludingThisOne?.length) {
            setSelectedFilm(filmsExcludingThisOne[0].id)
        }
    }, [filmId, filmsExcludingThisOne?.length]);

    const onCopyBackgroundActors = () => {
        copyBackgroundActors(filmId, selectedFilm, sameFilm);
    };

    if (redirect) {
        if (redirect.to == "list") {
            clearRedirect();
            const url = `/films/${filmId}/background-actors/overview`;
            return <Redirect to={url} />;
        }
    }

    return (
        <ScrollIntoView
            className="blade-content"
            path="/films/:filmId/background-actors/copy">
            <h2 className="menu-label">Copy Background Actors</h2>
            {(loadingFilms || importing) && <Loader />}
            <CopyBackgroundActors
                films={filmsExcludingThisOne}
                copyBackgroundActors={onCopyBackgroundActors}
                onChangeFilm={onChangeFilm}
                selectedFilm={selectedFilm}
                onChangeSameFilm={setSameFilm}
                sameFilm={sameFilm} />
            <Onboarding onboardingSteps={onboardingSteps} section="Copy Background Actors" />
        </ScrollIntoView>
    );
};

function mapStateToProps(state) {
    const { errors, importing, redirect, onboardingSteps } =
        state.backgroundActorsCopyState;
    return {
        films: state.filmsState.films,
        importing: importing,
        redirect: redirect,
        onboardingSteps: onboardingSteps,
        errors: errors
    };
}

export default connect(mapStateToProps, {
    fetchFilms,
    copyBackgroundActors,
    clearRedirect
})(CopyBackgroundActorsContainer);

